import { render, staticRenderFns } from "./unionEmployeeConfig.vue?vue&type=template&id=04388e31&"
import script from "./unionEmployeeConfig.vue?vue&type=script&lang=js&"
export * from "./unionEmployeeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports